import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const clickhouse = defineConnector({
  identifier: "clickhouse",
  name: "ClickHouse",
  tagLine: "Cloud analytics database",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: () => "https://api\\.clickhouse\\.cloud/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.keyId,
      password: app.secret.keySecret,
    }),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [ClickHouse Cloud console](https://clickhouse.cloud/), navigate to **Settings > API Keys**, and create a new key pair.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Key ID",
          required: true,
          target: { kind: "configuration", field: "keyId" },
        },
        {
          kind: "input",
          label: "Key secret",
          required: true,
          target: { kind: "secrets", field: "keySecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.clickhouse.cloud/v1/organizations",
  },
});
